<template>
  <b-modal
    id="team-modal"
    ref="teamModal"
    :title="`${update ? 'Update': 'Create New'} Team`"
    hide-footer
    size="md"
    @hidden="clear">
    <label
      class="col-form-label pt-0">
      Name
    </label>
    <b-form-group>
      <b-input
        v-model="name"
        autofocus
        placeholder="Add Name"/>
      <span
        v-if="validationErrors.name"
        class="validation-error clearfix">
        {{ validationErrors.name }}
      </span>
    </b-form-group>
    <label
      class="col-form-label pt-0">
      Members
    </label>
    <b-form-group>
      <multiselect
        v-model="selectedUsers"
        :options="members"
        :multiple="true"
        :hide-selected="true"
        :show-labels="false"
        class="multi-scoped"
        open-direction="bottom"
        placeholder="Select Members"
        label="name"
        track-by="id"/>
      <span
        v-if="validationErrors.userIds"
        class="validation-error clearfix">
        {{ validationErrors.userIds }}
      </span>
    </b-form-group>
    <span
      v-if="errorMessage"
      class="error-message">
      {{ errorMessage }}
    </span>
    <b-button
      :class="{loading: saving}"
      :disabled="saving"
      class="btn-round btn-block mt-4 mb-4"
      @click="saveTeam">
      <span v-if="!saving">Save</span>
      <div class="loader"><div class="loading-circle"/></div>
    </b-button>
  </b-modal>
</template>

<style lang="scss" scoped>
.multi-scoped::v-deep .multiselect__tags {
  border: 1px solid $inputBorderColor;
}
</style>

<script>
import { mapActions, mapGetters } from 'vuex';
import Multiselect from 'vue-multiselect';
import setValidationErrors from '@/helpers/validationErrors';

export default {
  name: 'TeamModal',
  components: {
    Multiselect,
  },
  props: {
    teamp: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      name: '',
      selectedUsers: [],
      update: false,
      saving: false,
      errorMessage: '',
      validationErrors: {},
    };
  },
  computed: {
    ...mapGetters({
      members: 'merchant/members',
      teamSaved: 'team/teamSaved',
      apiError: 'team/apiError',
    }),
  },
  watch: {
    teamSaved(saved) {
      if (saved) {
        this.saving = false;
        this.$emit('saved', saved);
        this.hide();
      }
    },
    apiError(error) {
      this.saving = false;
      if (error.status === 422) {
        this.validationErrors = setValidationErrors(error.data.errors);
      } else {
        this.errorMessage = error.data.message;
      }
    },
  },
  mounted() {
    if (!this.members.length) {
      this.fetchMembers(this.$route.params.merchant_id);
    }
  },
  methods: {
    ...mapActions({
      fetchMembers: 'merchant/fetchMembers',
      createTeam: 'team/createTeam',
      updateTeam: 'team/updateTeam',
    }),
    setTeamData() {
      if (!this.$lodash.isEmpty(this.teamp)) {
        this.update = true;
        this.name = this.teamp.name;
        this.selectedUsers = this.teamp.users;
      } else {
        this.clear();
      }
    },
    saveTeam() {
      this.saving = true;
      this.validationErrors = {};
      const data = {
        name: this.name,
        user_ids: this.selectedUsers.map(user => user.id),
      };

      if (this.update) {
        this.updateTeam({
          merchant_id: this.$route.params.merchant_id,
          team_id: this.teamp.id,
          data,
        });
      } else {
        this.createTeam({
          merchant_id: this.$route.params.merchant_id,
          data,
        });
      }
    },
    show() {
      this.setTeamData();
      this.$refs.teamModal.show();
    },
    clear() {
      Object.assign(this.$data, this.$options.data.apply(this));
    },
    hide() {
      this.$refs.teamModal.hide();
    },
  },
};
</script>
